import graph from '../svgs/black-chart.svg';
import performance from '../svgs/black-scale.svg';
import boxsensor from '../svgs/black-sensor.svg';
import info from '../svgs/black-info-circle.svg';
import map from '../svgs/black-map.svg';
import table from '../svgs/black-table.svg';
import Spinner from '../svgs/blue-big-spinner-animated.svg';
import Gear from '../svgs/blue-big-gear-animated.svg';
import pin from '../svgs/blue-two-toned-location-pin.svg';
import pinWhite from '../svgs/white-map-pin.svg';
import arrowUp from '../svgs/white-small-arrow-up.svg';
import arrowDown from '../svgs/white-small-arrow-down.svg';
import arrowLeft from '../svgs/blue-medium-arrow-left.svg';
import equal from '../svgs/white-small-equal.svg';
import signOut from '../svgs/blue-sign-out.svg';
import fleetMapIcon from '../svgs/blue-ship-map-pin.svg';
import clickedFleetMapIcon from '../svgs/orange-ship-map-pin.svg';
import DropArrowDown from '../svgs/white-small-down.svg';
import mapLegendIcon from '../svgs/blue-small-list.svg';
import closeIcon from '../svgs/white-big-cross.svg';
import marke1Icon from '../svgs/marke-1-sign.svg';
import marke2Icon from '../svgs/marke-2-sign.svg';

import whiteMediumArrowLeft from '../svgs/white-medium-arrow-left.svg';

const Images = {
  graph,
  performance,
  boxsensor,
  info,
  map,
  table,
  Spinner,
  Gear,
  pin,
  pinWhite,
  arrowUp,
  arrowDown,
  arrowLeft,
  equal,
  signOut,
  fleetMapIcon,
  clickedFleetMapIcon,
  DropArrowDown,
  mapLegendIcon,
  closeIcon,
  marke1Icon,
  marke2Icon,

  whiteMediumArrowLeft,
};
export default Images;
